import { $http } from "@/utils/http";
import { SET_BRANCHES, OPEN_POPUP_BRANCHES, SET_CURRENT_BRANCH } from "../mutation-types";
//
import { GET_BRANCHES } from "../action-types";
//
//
const state = {
    branchesList: "",
    openBranchesPopup: true,
    currentBranch: localStorage.getItem("branchId") ? JSON.parse(localStorage.getItem("branchId")) : null,
};

const getters = {
    branchesList: state => state.branchesList,
    openBranchesPopup: state => state.openBranchesPopup,
    currentBranch: (state) => {
        return !!state.currentBranch ? state.currentBranch : state.branchesList[0];
    },};
//
const actions = {
    [GET_BRANCHES]: async ({ commit }) => {
        try {
            const response = await $http.get(`v1/chapters`);
            commit(SET_BRANCHES, response.data.data.filter(item => item.id !== 3));
        } catch (e) {
            throw e;
        } finally {
        }
    },
};
//
const mutations = {
    [SET_BRANCHES](state, list) {
        state.branchesList = list;
    },
    [OPEN_POPUP_BRANCHES](state, status) {
        state.openBranchesPopup = status;
    },
    [SET_CURRENT_BRANCH](state, item) {
        state.currentBranch = item;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
